import React from 'react';
import { registerWidget } from '@okapi/core';
import { getGlobalRouter } from '@okapi/router-react';
import { SITEMAP_LANDING_NAME } from 'landings/sitemap';
import { FETCH_SITEMAP } from 'modules/sitemap';
import { GlobalEvents } from 'modules/global';
import { CookiesEvents } from 'modules/cookies';
import { FETCH_MODEL } from 'modules/model-json';
import { createStore } from 'store';
import { State } from 'store/types';
import { SitemapRemote } from '../../common/widgets';

registerWidget<State, Record<string, string>>(`${__NAME__}/${SITEMAP_LANDING_NAME}`, state => {
  const router = getGlobalRouter();
  const store = createStore();

  store.dispatch(GlobalEvents.setRequestParams, {
    orchestratorHost: state.orchestratorHost,
    useCredentials: state.useCredentials,
    apiKey: state.apiKey,
    requestID: state.requestID,
  });
  store.dispatch(GlobalEvents.setIsBot, state.isBot);
  store.dispatch(GlobalEvents.setUserAgent, state.userAgent);
  store.dispatch(CookiesEvents.set, document.cookie);
  store.dispatch(FETCH_MODEL.setModelState, state.modelJson);

  store.dispatch(FETCH_SITEMAP.success, state.sitemap.pageList ?? []);

  return remoteProps => <SitemapRemote router={router} store={store} {...remoteProps} />;
});
